import { NavDrawer, NavDrawerHeader, NavDrawerPinToggleButton, NavDrawerProps } from '@procureai/ui-mui';
import { Trans } from 'react-i18next';

import { NBSP } from '~/common/constants';
import { NavId } from '~/common/types';

export interface NavDrawerSimpleProps extends NavDrawerProps {
  navId?: NavId;
}

export const NavDrawerSimple = ({ navId, onPinToggle, ...props }: NavDrawerSimpleProps) => {
  return (
    <NavDrawer
      {...props}
      header={
        <NavDrawerHeader
          title={navId ? <Trans i18nKey={`Nav.${navId}`} /> : NBSP}
          actions={
            <NavDrawerPinToggleButton
              active={props.pinned}
              onClick={() => {
                onPinToggle?.(!props.pinned);
              }}
            />
          }
        />
      }
    />
  );
};
